module.exports = __webpack_public_path__ + "img/googlePlayDark.6fba8ab9.svg";